// extracted by mini-css-extract-plugin
module.exports = {"search":"search_search__2MARy","icon":"search_icon__2kv-1","fa":"search_fa__5c7Ts"};